import { useEffect, useRef } from "react";
import gql from "graphql-tag";
import { useLocation } from "react-router-dom";

import { TrackPageView } from "generated/copilot-api-developer";
import { useMutation } from "graphql-client/useMutation";

import { matchTrackedRoute } from "./trackedRoutes";

gql`
  # schema = COPILOT_API_DEVELOPER
  mutation TrackPageView(
    $page: ConsolePage!
    $path: String!
    $route: String!
    $routeParams: String
  ) {
    trackPageView(
      page: $page
      path: $path
      route: $route
      routeParams: $routeParams
    )
  }
`;

export const PageViewTracker = () => {
  const { pathname } = useLocation();

  const [trackPageView] = useMutation(TrackPageView, {
    onError: () => {
      /* Tracking must never break the app. */
    },
  });

  const lastTrackedPathname = useRef<string | null>();
  useEffect(() => {
    const match = matchTrackedRoute(pathname);
    if (match === undefined) {
      lastTrackedPathname.current = null;
      return;
    }
    if (lastTrackedPathname.current === pathname) return;
    lastTrackedPathname.current = pathname;
    void trackPageView({
      page: match.page,
      path: match.path,
      route: match.route,
      routeParams:
        Object.keys(match.params).length > 0
          ? JSON.stringify(match.params)
          : null,
    });
  }, [pathname, trackPageView]);

  return null;
};
